import { RadioBtn } from '@aon/aon-tws-common-ui';
import React from 'react';
import ContentConstants from '../../../contentConstants';
import { Col3Col9, LabelAbove } from '../../common';

export interface IQuestionNumberingSectionProps {
	disabled?: boolean;
	shouldShowQuestionNumbering: boolean;
	onChange: (isNumberingOn: boolean) => void;
}

export const QuestionNumberingSection = ({ disabled, shouldShowQuestionNumbering, onChange }: IQuestionNumberingSectionProps) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => onChange(!!+event.target.value);

	return (
		<Col3Col9 label={ContentConstants.SUBSECTIONHEADERS_QUESTION_NUMBERING}>
			<LabelAbove type='input'>{ContentConstants.SECTION_DESCRIPTION_QUESTION_NUMBERING}</LabelAbove>
			<RadioBtn
				checked={shouldShowQuestionNumbering}
				disabled={disabled}
				label={ContentConstants.INPUTLABEL_QUESTION_NUMBERING_YES}
				name='questionNumbering'
				value={1}
				onChange={handleChange}
			/>
			<RadioBtn
				checked={!shouldShowQuestionNumbering}
				disabled={disabled}
				label={ContentConstants.INPUTLABEL_QUESTION_NUMBERING_NO}
				name='questionNumbering'
				value={0}
				onChange={handleChange}
			/>
		</Col3Col9>
	);
};
